import { Table, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@trackman/web-shared-components';
import React from 'react';
import styled, { css } from 'styled-components';
import { grey } from 'styles/Colors';

export const StyledTableBodyRow = styled((props) => <TableRow {...props} />)`
  &&&&& {
    height: 64px;

    p {
      margin-bottom: 0;
    }

    background-color: ${({ theme }) => theme.oddRow};

    &&&:hover {
      background-color: ${({ theme }) => theme.oddRowHover};
    }

    .MuiSkeleton-root {
      background-color: ${({ theme }) => theme.skeletonBackgroundColor};

      &::after {
        background: ${({ theme }) => theme.skeletonPillBackground};
      }
    }
  }
`;

export const StyledTableBodyCell = styled((props) => <TableCell {...props} />)`
  &&& {
    color: ${({ theme }) => theme.rowColor};
    border-bottom: 1px solid ${({ theme }) => theme.tableBorderColor};

    &.no-data {
      background-color: ${({ theme }) => theme.noDataBackgroundColor};
    }
  }
`;

export const StyledNoData = styled.div`
  padding: 16px 12px;
  background-color: ${({ theme }) => theme.oddRow};
  text-align: center;
`;

export const StyledTableHeadRow = styled((props) => <TableRow {...props} />)`
  height: 48px;
  padding: 0 24px;
  border-radius: 8px 8px 0 0;

  &&& {
    background-color: ${({ theme }) => theme.tableHeader};
  }
`;

export const PinnedFilters = styled.div`
  padding: 6px 0;
  background-color: ${({ theme }) => theme.pinnedFiltersBackground};
`;

export const StyledTableHeadCell = styled((props) => <TableCell {...props} />)`
  &&& {
    color: ${({ theme }) => theme.rowColor};
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 18.2px;
    border-bottom: 1px solid ${({ theme }) => theme.tableBorderColor};

    white-space: nowrap;

    .Mui-active,
    .MuiButtonBase-root:hover {
      color: ${({ theme }) => theme.rowColor};
    }

    svg path {
      fill: ${({ theme }) => theme.rowColor};
    }
  }
`;

export const StyledTableRow = styled((props) => <TableRow {...props} />)`
  height: 64px;
  p {
    margin-bottom: 0;
  }
`;

export const StyledHeadRow = styled((props) => <TableRow {...props} />)``;

export const SubHeader = styled.div`
  color: ${grey};
  font-family: Lato;
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
`;

export const TableHeaderCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const StyledTable = styled((props) => <Table {...props} />)`
  border: 1px solid ${({ theme }) => theme.tableBorderColor};
`;

export const StyledTableHead = styled((props) => <TableHead {...props} />)<{ stickyHeader?: boolean }>`
  ${(props) =>
    props.stickyHeader &&
    css`
      position: sticky;
      top: 0;
    `}
`;

export const StyledTableFooter = styled((props) => <TableFooter {...props} />)`
  background-color: ${({ theme }) => theme.tableFooterBackgroundColor};
  border: none;

  p {
    margin-bottom: 0;
  }

  &&& {
    .MuiTablePagination-selectLabel,
    .MuiInputBase-root,
    .MuiInputBase-input {
      color: ${({ theme }) => theme.tableFooterColor};
    }

    svg path {
      fill: ${({ theme }) => theme.tableFooterColor};
    }

    .MuiInputBase-input {
      background-color: ${({ theme }) => theme.tableFooterBackgroundColor};
    }

    .MuiButtonBase-root {
      background-color: ${({ theme }) => theme.iconButtonBackgroundColor};
    }

    .MuiTableCell-footer {
      border-color: ${({ theme }) => theme.tableBorderColor};
    }
  }
`;

export const StickyColumnBackgroundCover = styled.div`
  height: 25px;
  width: 100%;
  background-color: ${({ theme }) => theme.tableFooterBackgroundColor};
`;

export const TableContainerWrapper = styled.div``;
